module.exports = "/fonts/mpn-logotype-l-27df1c18c7a6216d08ad5dcf2bb62362.svg";